export default "__VITE_ASSET__C7gSUWQ5__"